// Dependencies
import { h, Component } from 'preact';

// Helpers
import {classNames} from 'lib/helpers'

// Style
import style from './style.less'

// Icons
import visa from '../../../assets/icons/svg/visaelectron.svg';
import mastercard from '../../../assets/icons/svg/mastercard.svg' 
import discover from '../../../assets/icons/svg/discover.svg'

// Component    
export default (props)=>{
    const classes = [
        props.class,
        style.icon
    ]

    switch(props.type){
        case 'VS':
            return <div class={classNames(...classes)}>
                <img src={visa} />
            </div>
        case 'MC':
            return <div class={classNames(...classes)}>
                <img src={mastercard} />
            </div>
        case 'DC':
            return <div class={classNames(...classes, style.discover)}>
                <img src={discover} />
            </div>
    }
}


// WEBPACK FOOTER //
// ./components/elements/CreditCardIcon/index.js